import(/* webpackMode: "eager", webpackExports: ["LegalPage"] */ "/builds/seayatech1/aztangofest-fe/src/components/design/pages/LegalPage.tsx");
